import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useApiClient } from '@/api/clients/useApiClient.util.ts';
import { CarAttentionItemDto } from '@/api/generated';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';
import { nullsToUndefined } from '@/utils/Nullable.utilityTypes.ts';

type Return = {
  attentionItems: CarAttentionItemDto[];
  isError: boolean;
  isLoading: boolean;
};

export const useGetCarsAttention = (params?: { enabled?: boolean }): Return => {
  const { carMaintenanceApi } = useApiClient();

  const { data, isError, isPending } = useQuery<CarAttentionItemDto[], AxiosError>({
    enabled: params?.enabled ?? true,
    meta: { disableErrorAlert: true },
    queryFn: async () => {
      const { data } = await carMaintenanceApi.getCarsAttention();
      return nullsToUndefined(data);
    },
    queryKey: [QueryKeyEnum.CARS.ATTENTION],
    staleTime: 60 * 1000,
  });

  return {
    attentionItems: data ?? [],
    isError,
    isLoading: isPending,
  };
};
